import { Box } from '@hover/blueprint';
import React from 'react';

import { InteractiveRenderingsCTA } from 'src/modules/renderings/components/RenderingsHub/RenderingsList/InteractiveRenderingsCTA';
import { RequestRevision } from 'src/modules/renderings/components/RenderingsHub/RenderingsList/RequestRevision';
import { SharedViewCTA } from 'src/modules/renderings/components/RenderingsHub/RenderingsList/SharedViewCTA';
import { CTA_BUTTON_CONTAINER_TEST_ID } from 'src/modules/renderings/components/RenderingsHub/RenderingsList/index';
import {
  useIsMobileSize,
  useIsSharedView,
  useIsTabletSize,
} from 'src/modules/renderings/hooks';
import { useReactNativeWebView } from 'src/shared/hooks';

const SharedViewPrimaryCTA = () => {
  const [isWebView] = useReactNativeWebView();

  if (isWebView) {
    return null;
  }

  return (
    <Box
      minWidth="248px"
      testId={CTA_BUTTON_CONTAINER_TEST_ID}
      width={{ base: '100%', tablet: 'unset', desktop: '100%' }}
    >
      <SharedViewCTA />
    </Box>
  );
};
const MobileSizePrimaryCTA = () => (
  <Box minWidth="248px" testId={CTA_BUTTON_CONTAINER_TEST_ID} width="100%">
    <InteractiveRenderingsCTA />
  </Box>
);

const TabletSizePrimaryCTA = () => (
  <Box minWidth="248px" testId={CTA_BUTTON_CONTAINER_TEST_ID}>
    <RequestRevision primaryCallToAction={false} />
  </Box>
);

const DesktopSizePrimaryCTA = () => null;

export const PrimaryCTA = () => {
  const isSharedView = useIsSharedView();
  const isTabletSize = useIsTabletSize();
  const isMobileSize = useIsMobileSize();

  if (isSharedView) {
    return <SharedViewPrimaryCTA />;
  }

  if (isMobileSize) {
    return <MobileSizePrimaryCTA />;
  }

  if (isTabletSize) {
    return <TabletSizePrimaryCTA />;
  }
  // The Desktop size returns null, but we're keeping this
  // here for consistency with the format of the SecondaryCTA component
  return <DesktopSizePrimaryCTA />;
};
